<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayOutBillType="{ row }">
        {{ row.outBillType }}
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-dropdown trigger="click" @command="exportFile" v-if="allow('E')">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$l('INDEX.btn_export') || '导出'"
              placement="top"
            >
              <i class="el-icon-download tool-btn"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown" class="export-dropdown-menu">
              <el-dropdown-item
                v-for="task in exportTasks"
                :key="task.templateGroup"
                :command="{ ...row, ...task }"
              >
                {{ task.exportName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ExportProductPacking
      :title="
        $l('INDEX.dialog_title_export_container_choose') ||
          '选择需要导出的装柜记录'
      "
      :visible.sync="exportInstallationOptions.visible"
      :shipmentCode="exportInstallationOptions.shipmentCode"
      @confirm="confirm"
    />
    <ExportInventoryEntryDetails
      :title="
        $l('INDEX.dialog_title_export_container_choose') ||
          '选择需要导出的装柜记录'
      "
      :visible.sync="exportInventoryEntryDetailsOptions.visible"
      :shipmentCode="exportInventoryEntryDetailsOptions.shipmentCode"
      @confirm="confirm"
    />
    <ExportPackingOrder
      :title="
        $l('INDEX.tips_select_the_booking_record_to_export_notice') ||
          '选择需要导出发运通知书的订舱记录'
      "
      v-if="exportPackingOrderOptions.visible"
      :visible.sync="exportPackingOrderOptions.visible"
      :shipmentCode="exportPackingOrderOptions.shipmentCode"
      @confirm="confirm"
    />
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
      @confirmClose="confirmClose"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import exportTasks from './export-tasks'
import EditLoading from '@/mixins/edit-loading'
import ExportProductPacking from '@/views/factory/transport/waitProductionLoad/components/export-productpacking'
import ExportInventoryEntryDetails from '@/views/factory/transport/waitProductionLoad/components/export-inventoryentrydetails'
import ExportPackingOrder from '@/views/factory/transport/waitsettlement/components/export-packing-order'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: {
    ChooseTemplate,
    ExportProductPacking,
    ExportInventoryEntryDetails,
    ExportPackingOrder,
  },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      exportTasks: exportTasks(this),
      exportInstallationOptions: {
        visible: false,
        shipmentCode: '',
      },
      exportInventoryEntryDetailsOptions: {
        visible: false,
        shipmentCode: '',
      },
      exportPackingOrderOptions: {
        visible: false,
        shipmentCode: '',
      },
      chooseTemplateOptions: {
        visible: false,
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
        exportParams: {
          shipmentCode: '',
        },
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-allShipment-detail',
        params: { ...params, pageType },
        query,
      })
    },
    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      // const context = {
      //   shipmentCode,
      // }
      // let typeData = {}
      switch (templateGroup) {
        case 'shipment-clrform':
        case 'shipment-siformat':
        case 'shipment-productpacking':
        case 'shipment-packingList':
        case 'shipment-truckingOrder':
        case 'factory-truckPlan':
          this.exportInstallationOptions = {
            visible: true,
            shipmentCode: shipmentCode,
          }
          this.chooseTemplateOptions = {
            visible: false,
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
          return
        case 'shipment-inventoryentrydetails':
          this.exportInventoryEntryDetailsOptions = {
            visible: true,
            shipmentCode: shipmentCode,
          }
          this.chooseTemplateOptions = {
            visible: false,
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
          return
        case 'shipment-shippingadvice':
          this.exportPackingOrderOptions = {
            visible: true,
            shipmentCode: shipmentCode,
          }
          this.chooseTemplateOptions = {
            visible: false,
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
          return
        default:
          this.chooseTemplateOptions = {
            visible: true,
            exportParams: { shipmentCode },
            custCode,
            endCustCode,
            templateGroup,
            exportCheckUrl,
          }
          return
      }
    },
    confirm(data) {
      this.chooseTemplateOptions = {
        ...this.chooseTemplateOptions,
        visible: true,
        exportParams: { ...data },
      }
    },
    confirmClose() {
      this.exportPackingOrderOptions.visible = false
      this.exportInstallationOptions.visible = false
      this.exportInventoryEntryDetailsOptions.visible = false
    },
  },
}
</script>

<style>
.export-dropdown-menu.el-dropdown-menu.el-popper {
  max-height: 500px !important;
  overflow-y: auto !important;
}
</style>